<template>
  <div>
    <v-card-text class="py-0">
      <v-row>
        <v-col cols="12">
          <v-row class="align-center">
            <v-col cols="2" class="text-center" TITLE>
              <v-icon size="40" color="secondary">face</v-icon>
            </v-col>

            <v-col cols="10" TITLE>
              <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                {{ i18n["identity_confirmation"] }}
              </div>
              <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">
                {{ i18n['information_to_confirm_your_identity'] }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="secondary"
        :class="`${arabic ? 'arFont' : 'enFont'}`"
        @click="
          () => {
            dialog = true;
          }
        "
        :disabled="active_btn"
        >{{ i18n["add_id_and_submit_for_verification"] }}</v-btn
      >

      <v-dialog v-model="dialog" persistent max-width="800">
        <v-card :loading="loading">
          <v-card-title
            :class="`${arabic ? 'arFont' : 'enFont'}`"
            style="font-size:20px"
            >{{ i18n["confirm_account_identity"] }}
          </v-card-title>
          <v-card-text>
            <v-row class="align-center">
              <v-col cols="12" md="6" FIELD>
                <v-text-field
                  :label="i18n['upload_id_image']"
                  append-icon="attachment"
                  autocomplete="disabled"
                  v-model="id_url"
                  outlined
                  hide-details
                  clearable
                  dense
                  readonly
                  @click="pickFileImages()"
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  
                >
                </v-text-field>
                <v-progress-linear v-if="uploadProgress > 0" v-model="uploadProgress"></v-progress-linear>
                <input
                  type="file"
                  style="display: none"
                  ref="fileImages"
                  accept="csv/*"
                  @change="onFilePickedImages"
                >
            
              </v-col>
              <v-col cols="12" md="6" FIELD>
                <v-btn
                  color="primary"
                  :loading="loading"
                  @click.native="pickFileImages()"
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  >{{ i18n['upload_id_or_passport_image'] }}</v-btn>
              </v-col>
              <v-col cols="12" FIELD>
                <v-text-field
                  :label="i18n['name_as_in_passport']"
                  v-model="id_name"
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  outlined
                  hide-details
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions :class="`${arabic ? 'arFont' : 'enFont'}`">
            <v-spacer></v-spacer>
            {{ i18n["id_verification_is_being_proccessed"] }}
            <v-btn
              color="primary"
              text
              :loading="loading"
              @click.native="dialog = false"
              :class="`${arabic ? 'arFont' : 'enFont'}`"
              >{{ i18n["cancel"] }}</v-btn
            >
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="!this.id_name || !this.id_url"
              @click.native="submitId()"
              :class="`${arabic ? 'arFont' : 'enFont'}`"
              >{{ i18n["add"] }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          v-for="(sub, index) in data"
          :key="'sub-' + index"
          class="elevation-2 py-0 my-1"
        >
          <v-row class="py-0">
            <v-col cols="6" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="font-weight:bold;font-size:11px;"
              >
                {{ i18n["name_as_in_passport_short"] }}
              </div>
              {{ sub.id_name }}
            </v-col>

            <v-col cols="6" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="font-weight:bold;font-size:11px;"
              >
                {{ i18n['confirmation_image'] }}
              </div>
              <div><img :src="sub.url" width="100%" /></div>
            </v-col>

            <v-col cols="6" md="2" :class="`${arabic ? 'arFont' : 'enFont'}`">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="font-weight:bold;font-size:11px;"
              >
                {{ i18n["review_is_done"] }}
              </div>
              <div v-if="sub.reviewed">
                <v-icon    color="success">done</v-icon>
              </div>
              <div v-else>
                <v-icon color="error">close</v-icon>
              </div>
            </v-col>

            <v-col cols="6" md="2" :class="`${arabic ? 'arFont' : 'enFont'}`">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="font-weight:bold;font-size:11px;"
              >
                {{ i18n["approved"] }}
              </div>
              <div v-if="sub.approved">
                <v-icon color="success">done</v-icon>
              </div>
              <div v-else>
                <v-icon color="error">close</v-icon>
                <span
                  v-if="sub.reviewed"
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  >{{ i18n["rejected"] }}</span
                >
              </div>
            </v-col>

            <v-col
              cols="12"
              md="12"
              class="py-1"
              :class="`${arabic ? 'arFont' : 'enFont'}`"
              v-if="sub.note"
            >
              <v-divider></v-divider>
              <div class="font-weight-bold" >{{ i18n["note"] }}</div>
              <div class="error--text" >{{ sub.note }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import axios from "axios";
import { firebase, store, db, auth, storageRef } from '@/fb';
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';

export default {
  props: ["data"],
  data() {
    return {
      dialog: false,
      loading: false,
      id_url: null,
      id_name: null,
      account: {},
      uploadProgress:0,
      file:null,
      name:null,
      uploadURL:null,
    };
  },
  methods: {
    submitId() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        let sub_result = await this.$store.dispatch("postResource", {
          resource: "/id-verification",
          value: {
            url: this.id_url,
            id_name: this.id_name,
          },
        });
        this.dialog = false;
        this.$emit(
          "snackbarNotification",
          this.i18n["ur_data_is_sent_for_verification"],
          "success"
        );
        this.$emit('reloadSubs')
        this.loading = false;
      });
    },
    pickFileImages(){
      this.$refs.fileImages.click()
    },
    loadFileImages(file, type, ext){
      this.loading = true
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ninja/verification/user' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = progress
          }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          this.loading = false
					this.uploadProgress = 0
          this.id_url = downloadURL
        });
      });
    },
    onFilePickedImages (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFileImages(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.uploadURL = null
      }
    },
    goTo(path) {
      this.$router.push(path).catch((x) => {});
    },
  },
  computed: {
    active_btn(){
      return this.data.filter(d=>!d.reviewed).length ? true : false // 0
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(
        (x) => x.path == this.$route.path
      );
      let sub = []
        .concat(...this.$store.state.menu.map((x) => x.subs))
        .filter((x) => x)
        .filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      } else {
        return "";
      }
    },
    roles() {
      return this.$store.state.userRoles;
    },
    notifications() {
      return this.$store.state.notifications.sort(
        (a, b) => b.timestamp - a.timestamp
      );
    },
    paymentMethods() {
      return this.$store.state.paymentMethods;
    },
  },
};
</script>

<style></style>
